import React, { useEffect, useState } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { blue } from '@material-ui/core/colors';

import { TabPanel, a11yProps, useStyles } from './tabsConfig';
import { columnsDispensers } from './columnsDispensers';
import { CardTableToDispensers } from './CardTableToDispensers';



export const ConfigDispensers = (props) => {
  const { data, onClose } = props
  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [completeColumns, setCompleteColumns] = useState([])

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    data?.dispensers && setCompleteColumns( 
      data.dispensers.map( disp => {
        return {
          ...disp,
          column: columnsDispensers,
          table: <CardTableToDispensers idUnit={ data.id } data={disp} onClose={onClose}/>
                }
      } )
     )
  }, [data, onClose])

  return (
    <div className={classes.root}>
    <AppBar position="static">
      <Tabs value={value} onChange={handleChange} variant="scrollable" aria-label="scrollable auto tabs example" scrollButtons="auto" style={{ background: blue[900] }}>
        {data?.dispensers.map((disp, i) => (
          <Tab key={i} label={disp.name} {...a11yProps(i)} />
        ))}
      </Tabs>
    </AppBar>
    {completeColumns.map((disp, i) => (
      <TabPanel key={i} value={value} index={i}>
        {disp.table}
      </TabPanel>
    ))}
  </div>
  )
}
